module.exports = __webpack_public_path__ + "img/5.a1f83b05.jpg";